/* eslint-disable import/no-mutable-exports */
let browser: any = null
let engine: 'webkit' | 'gecko' | null = null
let platform: 'browser-webkit' | 'browser-gecko' | 'default' = 'default'
let isExtension: boolean = false

try {
  if (process.env.WEB_ENGINE?.startsWith('webkit')) {
    engine = 'webkit'
    platform = 'browser-webkit'
  }

  if (process.env.WEB_ENGINE === 'gecko') {
    engine = 'gecko'
    platform = 'browser-gecko'
  }

  if (['webkit-safari', 'webkit', 'gecko'].includes(process.env.WEB_ENGINE || '')) {
    // eslint-disable-next-line
    browser = require('webextension-polyfill')
    // Code running in a Chrome extension (content script, background page, etc.)
    // {@link https://stackoverflow.com/a/22563123/1333836}
    if (browser?.runtime?.id) isExtension = true
  }
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error)
}

const getFirefoxVersion = () => {
  const ua = navigator.userAgent
  if (!ua) return undefined

  try {
    const match = ua.match(/Firefox\/(\d+\.\d+)/)

    if (match) return parseInt(match[1], 10)

    return undefined
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    return undefined
  }
}

const isOpera = () => {
  try {
    const userAgent = navigator.userAgent
    return userAgent.includes('Opera') || userAgent.includes('OPR')
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    return false
  }
}

const isSafari = () => {
  try {
    return navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome')
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    return false
  }
}

// Detect a touch-first mobile browser (phone/tablet). Used to gate features
// that depend on desktop-only browser APIs — e.g. hardware-wallet flows need
// WebUSB/WebHID, which mobile Safari/Chrome don't expose, so those flows hang.
// Combines UA Client Hints (when present) with a UA regex + touch/width
// heuristic. Returns false on desktop, so callers are no-ops there.
const isMobileBrowser = () => {
  try {
    // Only trust a positive Client-Hints signal. A `false` here is unreliable —
    // some browsers freeze it and desktop UA spoofing leaves it false — so never
    // let it veto the UA/touch checks below.
    const uaData = (navigator as any).userAgentData
    if (uaData?.mobile === true) return true

    const ua = navigator.userAgent || ''
    if (/Android|iPhone|iPod/i.test(ua)) return true
    // iPadOS 13+ reports a desktop UA; fall back to touch + coarse pointer.
    const isIpad = /iPad/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1)
    if (isIpad) return true

    const hasTouch = navigator.maxTouchPoints > 0 || 'ontouchstart' in window
    const isNarrow = Math.min(window.innerWidth, window.innerHeight) < 768
    return hasTouch && isNarrow
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    return false
  }
}

const isVivaldi = async () => {
  // mobile-web has no webextension polyfill; skip rather than throw+log.
  if (!browser?.windows?.getCurrent) return false
  try {
    const currentWindow = await browser.windows.getCurrent()
    // Hackish way to detect if client's web browser is Vivaldi
    // {@link https://stackoverflow.com/a/77047611/1333836}
    return !!currentWindow?.vivExtData
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    return false
  }
}

export {
  engine,
  platform,
  isExtension,
  browser,
  getFirefoxVersion,
  isOpera,
  isSafari,
  isMobileBrowser,
  isVivaldi
}
